import { render, staticRenderFns } from "./IntegrationSubPage.vue?vue&type=template&id=8564ea94"
import script from "./IntegrationSubPage.vue?vue&type=script&lang=js"
export * from "./IntegrationSubPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports